import { render, staticRenderFns } from "./VideoIdSelector.vue?vue&type=template&id=841a6436&scoped=true&"
import script from "./VideoIdSelector.vue?vue&type=script&lang=js&"
export * from "./VideoIdSelector.vue?vue&type=script&lang=js&"
import style0 from "./VideoIdSelector.vue?vue&type=style&index=0&id=841a6436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841a6436",
  null
  
)

export default component.exports